import React from 'react';

import { Alert } from '@mui/material';

const ExpiredTokenMessage = () => {
  return <Alert severity="warning">Your auth token has expired. Please login again to continue.</Alert>;
};

export default ExpiredTokenMessage;
